import { Injectable } from '@angular/core';
import { SiteSettingsService } from '@shared/services/site-settings.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  public enableRecaptcha = false;
  constructor(private siteSettingsService: SiteSettingsService) {
    this.siteSettingsService
      .fetchSiteSettings()
      .pipe(take(1))
      .subscribe((data) => {
        this.enableRecaptcha = data?.switches?.enable_recaptchas;
      });
  }
  private isReCaptchaImplemented = new BehaviorSubject<boolean>(false);

  public setReCaptcha(flag: boolean) {
    if (this.enableRecaptcha) {
      this.isReCaptchaImplemented.next(flag);
    }
  }

  public getReCaptcha(): Observable<boolean> {
    return this.isReCaptchaImplemented.asObservable();
  }
}
